(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdf-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.mdfColtabsReady) return;
      root.dataset.mdfColtabsReady = '1';
      var tabs = root.querySelectorAll('.mdf-cols__tab');
      var panels = root.querySelectorAll('.mdf-cols__panel');
      function activate(tab, scroll) {
        var i = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === i);
        });
        if (scroll) {
          var sec = root.closest('.mdf-cols') || root;
          sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab, false);
          var h = tab.getAttribute('data-handle');
          if (h && history.replaceState) history.replaceState(null, '', '#' + h);
        });
      });
      var hash = (window.location.hash || '').replace('#', '').toLowerCase();
      if (hash) {
        var match = null;
        tabs.forEach(function (t) { if (t.getAttribute('data-handle') === hash) match = t; });
        if (match) activate(match, true);
      }
    }
    function run() { document.querySelectorAll('[data-mdf-coltabs]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdf-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.mdfTabsReady) return;
      root.dataset.mdfTabsReady = '1';
      var tabs = root.querySelectorAll('.mdf-guide__tab');
      var panels = root.querySelectorAll('.mdf-guide__panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-panel') === i);
          });
        });
      });
    }
    function run() {
      document.querySelectorAll('[data-mdf-tabs]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdf-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(el) {
      if (el.dataset.mdfStickyReady) return;
      el.dataset.mdfStickyReady = '1';
      var footerVisible = false;
      var footer = document.querySelector('.mdf-footer') || document.querySelector('footer');
      if (footer && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          update();
        }).observe(footer);
      }
      function update() {
        if (window.scrollY > 480 && !footerVisible) {
          el.classList.add('is-on');
        } else {
          el.classList.remove('is-on');
        }
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
    }
    function run() {
      document.querySelectorAll('.mdf-sticky').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdf-urgency-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.currentScript.closest('.mdf-ubar');
    if (!el) return;
    var box = el.querySelector('[data-mdf-countdown]');
    if (!box) return;
    var h = box.querySelector('[data-h]');
    var m = box.querySelector('[data-m]');
    var s = box.querySelector('[data-s]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      var diff = Math.max(0, Math.floor((end - now) / 1000));
      h.textContent = pad(Math.floor(diff / 3600));
      m.textContent = pad(Math.floor((diff % 3600) / 60));
      s.textContent = pad(diff % 60);
    }
    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
